//混凝土填充svg.js

export function getAngle(R, R1, H2, bar_2d, bar_3d, bar_5d, cover_other) {
  let sita = Math.PI / 2 + Math.atan(H2.value / (R.value - R1.value));
  let x = cover_other.value + bar_5d.value + bar_2d.value / 2; //角点垂直于斜边的距离
  let y = cover_other.value + bar_3d.value + bar_2d.value / 2; //角点垂直于竖边的距离
  let b = Math.asin(
    //角点与竖边的夹角
    Math.sin(sita) /
      Math.sqrt(
        Math.pow(Math.sin(sita), 2) + Math.pow(Math.cos(sita) + x / y, 2)
      )
  );
  let a = sita - b; //角点与斜边的夹角

  return [a, b, x, y, sita]; //角度为弧度
}
